<!--
 * @Description: 万象/联合体月度销售额/毛利润统计（柱状图+折线图）
 * @Author: xiawenlong
 * @Date: 2024-11-25 14:22:25
 * @LastEditors: xiawenlong
-->
<template>
  <div class="wanxiang-monthly-stats">
    <div class="header">
      <div class="title">
        <img src="@/img/datav-tc/title_icon.png" alt="" />
        <span>万象/联合体月度销售额/毛利润统计</span>
      </div>
    </div>
    <div id="WanxiangChart" style="width:100%;height:calc(100% - 60px)"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getWanxiangMonthlyStats } from '@/api/dashboard-tc'
let myChart

export default {
  data() {
    return {
      data: {
        months: [],
        salesAmount: [],
        grossProfit: [],
        lhtSalesAmount: [],
        lhtGrossProfit: [],
      },
      timer: null,
    }
  },
  mounted() {
    myChart = echarts.init(document.getElementById('WanxiangChart'))
    myChart.resize()
    window.addEventListener('resize', () => {
      myChart.resize()
    })
    this.fetchData()
    this.timer = setInterval(() => {
      this.fetchData()
    }, process.env.VUE_APP_LTIME_TC)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async fetchData() {
      try {
        const res = await getWanxiangMonthlyStats()
        if (res.code === 0) {
          this.data.months = res.data.months
          this.data.salesAmount = res.data.salesAmount
          this.data.grossProfit = res.data.grossProfit
          this.data.lhtSalesAmount = res.data.lhtSalesAmount || []
          this.data.lhtGrossProfit = res.data.lhtGrossProfit || []
          this.initChart()
        }
      } catch (error) {
        console.error('获取月度统计失败:', error)
      }
    },
    initChart() {
      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(0, 192, 254, 0.5)',
          borderWidth: 1,
          padding: [10, 15],
          textStyle: {
            fontSize: 14,
            color: '#fff',
          },
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: 'rgba(0, 192, 254, 0.5)',
            },
          },
          extraCssText: 'box-shadow: 0 0 15px rgba(0, 192, 254, 0.4); border-radius: 4px;',
        },
        legend: {
          data: ['万象销售额', '万象毛利润', '联合体销售额', '联合体毛利润'],
          textStyle: {
            color: '#899DBF',
            fontSize: 14,
          },
          top: 10,
          right: 20,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '18%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: this.data.months,
            axisPointer: {
              type: 'shadow',
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              fontSize: 14,
              color: 'rgba(255, 255, 255, 0.7)',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '销售金额(万元)',
            nameTextStyle: {
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 12,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.1)',
                type: 'dashed',
              },
            },
            axisLabel: {
              fontSize: 12,
              color: 'rgba(255, 255, 255, 0.7)',
            },
          },
          {
            type: 'value',
            name: '毛利润(万元)',
            nameTextStyle: {
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 12,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              fontSize: 12,
              color: 'rgba(255, 255, 255, 0.7)',
            },
          },
        ],
        series: [
          {
            name: '万象销售额',
            type: 'bar',
            barWidth: '18%',
            barGap: '10%',
            data: this.data.salesAmount,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00C0FE' },
                { offset: 1, color: '#126DFF' },
              ]),
              borderRadius: [4, 4, 0, 0],
              shadowBlur: 12,
              shadowColor: 'rgba(0, 192, 254, 0.6)',
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 20,
                shadowColor: 'rgba(0, 192, 254, 0.8)',
              },
            },
          },
          {
            name: '联合体销售额',
            type: 'bar',
            barWidth: '18%',
            data: this.data.lhtSalesAmount,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00FF88' },
                { offset: 1, color: '#00AA55' },
              ]),
              borderRadius: [4, 4, 0, 0],
              shadowBlur: 12,
              shadowColor: 'rgba(0, 255, 136, 0.6)',
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 20,
                shadowColor: 'rgba(0, 255, 136, 0.8)',
              },
            },
          },
          {
            name: '万象毛利润',
            type: 'line',
            yAxisIndex: 1,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#FEDB65' },
                { offset: 1, color: '#FFA600' },
              ]),
              shadowBlur: 15,
              shadowColor: 'rgba(254, 219, 101, 0.6)',
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FEDB65' },
                { offset: 1, color: '#FFA600' },
              ]),
              borderColor: '#fff',
              borderWidth: 2,
              shadowBlur: 10,
              shadowColor: 'rgba(254, 219, 101, 0.8)',
            },
            emphasis: {
              scale: 1.5,
              itemStyle: {
                shadowBlur: 20,
                shadowColor: 'rgba(254, 219, 101, 1)',
              },
            },
            data: this.data.grossProfit,
          },
          {
            name: '联合体毛利润',
            type: 'line',
            yAxisIndex: 1,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#FF6B9D' },
                { offset: 1, color: '#FF3366' },
              ]),
              shadowBlur: 15,
              shadowColor: 'rgba(255, 107, 157, 0.6)',
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FF6B9D' },
                { offset: 1, color: '#FF3366' },
              ]),
              borderColor: '#fff',
              borderWidth: 2,
              shadowBlur: 10,
              shadowColor: 'rgba(255, 107, 157, 0.8)',
            },
            emphasis: {
              scale: 1.5,
              itemStyle: {
                shadowBlur: 20,
                shadowColor: 'rgba(255, 107, 157, 1)',
              },
            },
            data: this.data.lhtGrossProfit,
          },
        ],
      }
      myChart.setOption(option)
    },
  },
}
</script>

<style lang="scss" scoped>
.wanxiang-monthly-stats {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 25px 25px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .title {
      font-size: 24px;
      color: #ecf8ff;
      display: flex;
      align-items: center;

      img {
        margin-right: 3px;
      }
    }
  }
}
</style>
